<div [formGroup]="form">

  <div class="card">
    <div class="card-header">

      @if (closeButton) {
        <button type="button" class="btn-close float-end pt-1 pe-1 top-corner" aria-label="Close" (click)="close()"></button>
      }

      <app-equipment-select
        [formControlName]="CONTROL_NAME_EQUIPMENT"
        [siteId]="siteId"
        [optionsSearchTerm]="equipmentSearchTerm"
        [appendTo]="DROPDOWN_HOLDER_SELECTOR"
        (blur)="onTouched()"/>

      @if ((form.get(CONTROL_NAME_EQUIPMENT).touched || form.get(CONTROL_NAME_EQUIPMENT).dirty) && form.get(CONTROL_NAME_EQUIPMENT).hasError('required')) {
        <div class="invalid-feedback d-flex">
          {{'Select an Equipment' | messageTranslate}}
        </div>
      }

      @if (metadataConditionWarning) {
        <div class="d-flex text-warning small">
          <fa-icon icon="triangle-exclamation" class="me-1" [fixedWidth]="true"/>
          <span>{{metadataConditionWarning | messageTranslate}}</span>
        </div>
      }

    </div>

    <div class="card-body">
      <app-favourites-select
        bindLabel="metadata.name"
        [equipmentId]="equipmentId"
        [favourites]="favouritesForChildren"
        [optionsSearchTerm]="favouritesSearchTerm"
        [includeIdentifierInTooltip]="true"
        [hideSelected]="false"
        [formControlName]="CONTROL_NAME_FAVOURITES"
        [appendTo]="DROPDOWN_HOLDER_SELECTOR"
        (blur)="onTouched()"
        (loadingChange)="onFavouritesLoadingChange($event)"
        (favouritesLoaded)="onFavouritesLoaded($event)"/>

      <div class="float-end near-right opacity-50">
        <span class="clickable" (click)="isSelectFunctionDisabled() || selectFunction($event)"
              title="{{ 'Choose Function' | messageTranslate }}"
              [ngClass]="{'fa-disabled': isSelectFunctionDisabled()}">
          <fa-layers [fixedWidth]="true">
            <fa-icon [icon]="['fas', 'calculator']"/>
            <fa-layers-text [content]="getFunctionTextForIcon()" transform="shrink-4 down-16"/>
          </fa-layers>
        </span>
      </div>

      <app-errors [control]="form.controls.favourites"
                  [translatedErrorMessagesByType]="{required: {messageKey: 'Please select Favourites'}}"/>

      <div class="mb-3"></div>

      @if (showTasksSelect) {
        <app-rules-select
          bindLabel="template.template_name"
          [equipmentId]="equipmentId"
          [hideSelected]="false"
          [formControlName]="CONTROL_NAME_TASKS"
          [appendTo]="DROPDOWN_HOLDER_SELECTOR"
          (blur)="onTouched()"/>
      }

      <div class="float-end bottom-corner opacity-50 pb-2 pe-1">
        <span class="clickable" title="{{ 'Clone Favourites and Tasks Tooltip' | messageTranslate }}"
              (click)="copy()"
              [ngClass]="{'fa-disabled': isCloneDisabled()}">
          <fa-icon [appShowFaSpinner]="cloneInProgress" [icon]="['far', 'clone']"/>
        </span>
      </div>

    </div>
  </div>
</div>
